import { ISearchPage, IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";


//详情
export interface IAboutUsDetail {
    id?: string,              // "bf9dc1a3b9647038f96e545229b25e72",
    "name"?: string,   // "新增公司",
    "address"?: string,   // "地址",
    "code"?: string,   // "123",
    "logo"?: string,   // "5465",
    "profiles"?: string,   // "789"
    "html"?: string,   // "789"
    photo?: string,
}


//新增
export interface IAboutUsInsert {
    "name"?: string,   // "新增公司",
    "address"?: string,   // "地址",
    "code"?: string,   // "123",
    "logo"?: string,   // "5465",
    "profiles"?: string,   // "789"
    photo?: string,
}

//编辑
export interface IAboutUsUpdate extends IAboutUsInsert {
    id: string,
}

//搜索条件
export interface IAboutUsSearchFields {
    name?: string,      // "门店名称",
}
export interface ICmSearchPageFields {
    page: ISearchPage;
}
export interface IAboutUsSearch
    extends IAboutUsSearchFields, ICmSearchPageFields {
}

//表单字段
export interface IAboutUsFormFields {
    "name"?: string,   // "新增公司",
    "address"?: string,   // "地址",
    "code"?: string,   // "123",
    "photo"?: string[],  // "234", 
    "logo"?: string[],   // "5465",
    "profiles"?: any,   // "789"
    "html"?: string,   // "789"
}

class AboutUsService {
    async page(searchVo: IAboutUsSearch) {
        const apiUrl = "/ebc/company/search/pg";
        return await httpRequest.post<IPage<IAboutUsDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/ebc/company/select/${id}`;
        return await httpRequest.get<IAboutUsDetail>(apiUrl);
    }
    async insert(insertVo: IAboutUsInsert) {
        const apiUrl = "/ebc/company/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: IAboutUsUpdate) {
        const apiUrl = "/ebc/company/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //启用禁用
    async disable(id: string) {
        const apiUrl = `/ebc/company/delete/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }

}

export const aboutUsService = new AboutUsService();
